import { useContext, useEffect, useState } from 'react';
import { MainContext } from '../../../../../context/MainContext';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getConcreteClasses100 } from '../../../../../services/api/concreteClasses';
import { Collapse, Descriptions, Divider, Flex, theme } from 'antd';
import styles from './index.module.scss';
import AccionaButton from '../../../../../components/AccionaButton';
import { useIntl } from 'react-intl';
import { DownOutlined } from '@ant-design/icons';
import {
  getNonConformityBatch,
  getPosition,
  getTables,
  hasNonConformity,
  shouldShowCreateNC,
} from '../shared/utils.index';
import { getComplianceStyle, renderComplianceIcons } from './utils.index';
import BatchDeliveryTable from './components/BatchDeliveryTable/index';
import StrengthTestTable from './components/StrengthTestTable/index';

const { actionsWrapper } = styles;

const C100ControlBatchDetail = () => {
  const intl = useIntl();
  const { setLoading } = useContext(MainContext);
  const { batch, id } = useParams();
  const navigate = useNavigate();
  const [concreteBatches, setConcreteBatches] = useState();
  const [concreteClass, setConcreteClass] = useState();
  const { token } = theme.useToken();
  const [tables, setTables] = useState();
  const { me } = useSelector(({ auth }) => auth);

  useEffect(() => {
    setLoading(true);
    const findConcreteClass = async () => {
      const data = await getConcreteClasses100(id);
      if (!data) {
        navigate('../');
      } else {
        const concreteClass = data.data.data.find((c) => c.name === batch);
        const concreteBatchesData = concreteClass.concrete_batch_data
          .reduce((acc, cur) => {
            cur.delivery_note_data.forEach((dn) => {
              acc.push({
                ...dn,
                batch_code: cur.batch_code,
                batch_volume: cur.batch_volume,
                posicion_orden_xi: cur.posicion_orden_xi,
                total_control_mash: cur.total_control_mash,
                fcreal: cur.fcreal,
                concrete_value: cur.concrete_value,
                compliance: cur.compliance,
                compliance90: cur.compliance90,
                non_conformity: cur.non_conformity,
                tag_batch_data: cur.tag_batch_data,
              });
            });
            return acc;
          }, [])
          .sort((a, b) => a.mash_code - b.mash_code)
          .sort(
            (a, b) =>
              (b.mash_control === true ? 1 : 0) -
              (a.mash_control === true ? 1 : 0),
          );

        setConcreteBatches(concreteBatchesData);
        const tables = getTables(concreteBatchesData);
        setTables(tables);
        setConcreteClass(concreteClass);
        setLoading(false);
      }
    };

    findConcreteClass();
  }, [batch, id, navigate, setLoading]);
  return (
    <>
      <div className={`row ${actionsWrapper}`}>
        <div className="col-sm-12">
          <div className={`row ${actionsWrapper}`}>
            <div className="col-sm-12">
              <Flex justify="flex-end">
                <AccionaButton
                  style={{ padding: 15, marginRight: 'auto' }}
                  id="statisticalControl"
                  type="white"
                  onClick={() => {
                    navigate(`../100-control`);
                  }}
                  msg={intl.formatMessage({ id: 'back' })}
                  classIcon="icon fas fa-arrow-left"
                />
                <AccionaButton
                  id="traceability"
                  style={{ padding: 15 }}
                  type="primary"
                  onClick={() => {
                    navigate('../traceability');
                  }}
                  msg={intl.formatMessage({ id: 'button.traceability' })}
                  classIcon="icon fas fa-route"
                />
                <AccionaButton
                  style={{ padding: 15 }}
                  id="100%Control"
                  type="primary"
                  onClick={() => {
                    navigate(`../100-control`);
                  }}
                  msg={intl.formatMessage({ id: 'button.100%Control' })}
                  classIcon="icon fas fa-percentage"
                />
                <AccionaButton
                  style={{ padding: 15 }}
                  id="statisticalControl"
                  type="primary"
                  onClick={() => {
                    navigate(`../statistical-control`);
                  }}
                  msg={intl.formatMessage({ id: 'button.statisticalControl' })}
                  classIcon="icon fas fa-chart-bar"
                />
              </Flex>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <Collapse
            defaultActiveKey={['1']}
            expandIconPosition="end"
            expandIcon={({ isActive }) => (
              <DownOutlined rotate={isActive ? 180 : 0} />
            )}
            style={{ background: 'transparent', border: 'none' }}
            items={[
              {
                key: '1',
                label: (
                  <Flex justify="flex-start" gap="8px" align="center">
                    <span>CONTROL 100%</span>
                    <Divider type="vertical" />
                    <span>
                      {intl
                        .formatMessage({
                          id: 'pages.quality.normative.100-control.batchDetail.criteria',
                          defaultMessage: 'Criterio aceptado',
                        })
                        .toUpperCase()}
                      : ∫creal ≥ ∫ck
                    </span>
                  </Flex>
                ),
                children: (
                  <Descriptions column={2} bordered>
                    <Descriptions.Item
                      key="className"
                      label={intl
                        .formatMessage({
                          id: 'pages.quality.normative.100-control.batchDetail.className',
                          defaultMessage: 'Clase Hormigón Obra',
                        })
                        .toLocaleUpperCase()}
                      styles={{
                        content: { width: '25%' },
                        label: { width: '25%' },
                      }}
                    >
                      {concreteClass?.name}
                    </Descriptions.Item>
                    <Descriptions.Item
                      styles={{
                        content: { width: '25%' },
                        label: { width: '25%' },
                      }}
                      key="position_order_xi"
                      label={intl.formatMessage({
                        id: 'pages.quality.normative.100-control.batchDetail.position_order_xi',
                        defaultMessage: 'Posición ORDEN Xi',
                      })}
                    >
                      {getPosition(concreteBatches?.[0].total_control_mash)}
                    </Descriptions.Item>
                    <Descriptions.Item
                      key="plant"
                      label={intl
                        .formatMessage({
                          id: 'pages.quality.normative.100-control.batchDetail.plant',
                          defaultMessage: 'Planta',
                        })
                        .toLocaleUpperCase()}
                    >
                      {concreteClass?.plant}
                    </Descriptions.Item>
                    <Descriptions.Item
                      key="fcreal"
                      label={intl.formatMessage({
                        id: 'pages.quality.normative.100-control.batchDetail.fcreal',
                        defaultMessage: '∫creal',
                      })}
                    >
                      {concreteBatches?.[0].fcreal?.toFixed(2)}
                    </Descriptions.Item>
                    <Descriptions.Item
                      key="recipe"
                      label={intl
                        .formatMessage({
                          id: 'pages.quality.normative.100-control.batchDetail.recipe',
                          defaultMessage: 'Tipo de Hormigón',
                        })
                        .toLocaleUpperCase()}
                    >
                      {concreteClass?.recipe}
                    </Descriptions.Item>
                    <Descriptions.Item
                      key="concrete_value"
                      label={
                        concreteClass?.concrete_quality === true
                          ? '∫ck / ∫ck 90%'
                          : '∫ck'
                      }
                    >
                      {concreteClass?.concrete_quality === true
                        ? `${concreteBatches?.[0]?.concrete_value?.toFixed(
                            2,
                          )} / ${(
                            concreteBatches?.[0]?.concrete_value * 0.9
                          )?.toFixed(2)}`
                        : concreteBatches?.[0]?.concrete_value?.toFixed(2)}
                    </Descriptions.Item>
                    <Descriptions.Item
                      key="total_control_mash"
                      label={intl
                        .formatMessage({
                          id: 'pages.quality.normative.100-control.batchDetail.total_control_mash',
                        })
                        .toLocaleUpperCase()}
                    >
                      {concreteBatches?.[0]?.total_control_mash}
                    </Descriptions.Item>
                    <Descriptions.Item
                      key="compliance"
                      label={intl
                        .formatMessage({
                          id:
                            concreteClass?.concrete_quality === true
                              ? 'pages.quality.normative.100-control.batchDetail.compliance90'
                              : 'pages.quality.normative.100-control.batchDetail.compliance',
                        })
                        .toUpperCase()}
                      styles={getComplianceStyle(
                        concreteClass,
                        concreteBatches,
                        token,
                      )}
                    >
                      {renderComplianceIcons(
                        concreteClass,
                        concreteBatches,
                        token,
                        intl,
                      )}
                    </Descriptions.Item>
                  </Descriptions>
                ),
              },
            ]}
          />
          <Divider />
          {concreteBatches?.length > 0 && (
            <BatchDeliveryTable data={concreteBatches} />
          )}
          {tables?.before3Tables.length > 0 &&
            tables?.before3Tables.map((table, index) => (
              <div key={index} style={{ marginTop: '3em' }}>
                <StrengthTestTable
                  data={table.sameDay}
                  days={table.extraDay}
                  title={intl.formatMessage(
                    {
                      id: 'pages.quality.normative.100-control.batchDetail.table.title_dynamic',
                      defaultMessage: 'TABLA DE ROTURA A {days} DÍAS',
                    },
                    { days: table.extraDay },
                  )}
                />
              </div>
            ))}
          {tables?.d3Table.length > 0 && (
            <div style={{ marginTop: '3em' }}>
              <StrengthTestTable
                data={tables?.d3Table}
                days={3}
                title={intl.formatMessage({
                  id: 'pages.quality.normative.100-control.batchDetail.table.title_3',
                  defaultMessage: 'TABLA DE ROTURA A 3 DÍAS [INFORMATIVO]',
                })}
              />
            </div>
          )}
          {tables?.before7Tables.length > 0 &&
            tables?.before7Tables.map((table, index) => (
              <div key={index} style={{ marginTop: '3em' }}>
                <StrengthTestTable
                  data={table.sameDay}
                  days={table.extraDay}
                  title={intl.formatMessage(
                    {
                      id: 'pages.quality.normative.100-control.batchDetail.table.title_dynamic',
                      defaultMessage: 'TABLA DE ROTURA A {days} DÍAS',
                    },
                    { days: table.extraDay },
                  )}
                />
              </div>
            ))}
          {tables?.d7Table.length > 0 && (
            <div style={{ marginTop: '3em' }}>
              <StrengthTestTable
                data={tables?.d7Table}
                days={7}
                title={intl.formatMessage({
                  id: 'pages.quality.normative.100-control.batchDetail.table.title_7',
                  defaultMessage: 'TABLA DE ROTURA A 7 DÍAS [INFORMATIVO]',
                })}
              />
            </div>
          )}
          {tables?.before28Tables.length > 0 &&
            tables?.before28Tables.map((table, index) => (
              <div key={index} style={{ marginTop: '3em' }}>
                <StrengthTestTable
                  data={table.sameDay}
                  days={table.extraDay}
                  title={intl.formatMessage(
                    {
                      id: 'pages.quality.normative.100-control.batchDetail.table.title_dynamic',
                      defaultMessage: 'TABLA DE ROTURA A {days} DÍAS',
                    },
                    { days: table.extraDay },
                  )}
                />
              </div>
            ))}
          {concreteBatches?.length > 0 && (
            <div style={{ marginTop: '3em' }}>
              <StrengthTestTable
                data={concreteBatches}
                days={28}
                title={intl.formatMessage({
                  id: 'pages.quality.normative.100-control.batchDetail.table.title_28',
                  defaultMessage: 'TABLA DE ROTURA A 28 DÍAS [CUMPLIMIENTO]',
                })}
                totalCount={concreteBatches?.length}
              />
            </div>
          )}
          {tables?.afterTables.length > 0 &&
            tables?.afterTables.map((table, index) => (
              <div key={index} style={{ marginTop: '3em' }}>
                <StrengthTestTable
                  data={table.sameDay}
                  days={table.extraDay}
                  title={intl.formatMessage(
                    {
                      id: 'pages.quality.normative.100-control.batchDetail.table.title_dynamic',
                      defaultMessage: 'TABLA DE ROTURA A {days} DÍAS',
                    },
                    { days: table.extraDay },
                  )}
                />
              </div>
            ))}
          {tables?.d60Table.length > 0 && (
            <div style={{ marginTop: '3em' }}>
              <StrengthTestTable
                data={tables?.d60Table}
                days={60}
                title={intl.formatMessage({
                  id: 'pages.quality.normative.100-control.batchDetail.table.title_60',
                  defaultMessage: 'TABLA DE ROTURA A 60 DÍAS [INFORMATIVO]',
                })}
              />
            </div>
          )}
        </div>
      </div>
      <Divider />
      <div className={`row ${actionsWrapper}`}>
        <div className="col-sm-12">
          <div className={`row ${actionsWrapper}`}>
            <div className="col-sm-12">
              <Flex justify="flex-end">
                <AccionaButton
                  style={{ padding: 15, marginRight: 'auto' }}
                  id="statisticalControl"
                  type="white"
                  onClick={() => {
                    navigate(`../100-control`);
                  }}
                  msg={intl.formatMessage({ id: 'back' })}
                  classIcon="icon fas fa-arrow-left"
                />
                {hasNonConformity(concreteBatches) && (
                  <AccionaButton
                    id="traceability"
                    style={{ padding: 15 }}
                    type="primary"
                    onClick={() => {
                      navigate(
                        `../../ocr/nonConformity/${getNonConformityBatch(
                          concreteBatches,
                        )}`,
                      );
                    }}
                    msg={intl.formatMessage({
                      id: 'pages.quality.normative.100-control.batchDetail.nonConformityList.button',
                      defaultMessage: 'Ver NC',
                    })}
                  />
                )}
                {shouldShowCreateNC(concreteBatches) && (
                  <AccionaButton
                    style={{ padding: 15 }}
                    id="createNC"
                    disabled={!me.is_active}
                    type="primary"
                    onClick={() => {
                      const position = getPosition(
                        concreteBatches?.[0].total_control_mash,
                      );
                      const concreteBatch = concreteBatches[position - 1];
                      const avg = concreteBatch.posicion_orden_xi;
                      const batchForNC = concreteBatches.find(
                        (cb) =>
                          cb.laboratory_note_data?.ave_strength_28_2 === avg ||
                          cb.laboratory_note_data?.ave_strength_28_3 === avg,
                      ).concrete_batch;
                      navigate(`../../ocr/nonConformity/create/${batchForNC}`);
                    }}
                    msg={intl.formatMessage({
                      id: 'pages.quality.normative.100-control.batchDetail.createNC.button',
                      defaultMessage: 'Crear NC',
                    })}
                  />
                )}
              </Flex>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default C100ControlBatchDetail;
